import { get } from '../helpers/objectHelper';

/**
* Helper for products
*
* @param {object} product - the project object
* @param {string} iso_currency_code - the iso currency code 
*/
export function productData(product, iso_currency_code){

    const _priceFrom =  get(['pricesFrom'], product, []);
    const _priceFilter = _priceFrom.filter(item => item.iso_currency_code === iso_currency_code);
    const _price = _priceFilter.length !== 0 ? _priceFilter[0].amount : "";
    const _videoId = get(['videoId'], product, null);

    return {
        name: get(['name'], product, ""),
        tourId:get(['tourId'], product, ""),
        duration: get(['duration'], product, ""),
        mapImage: get(['mapImage'], product, ""),
        heroImage: get(['hero'], product, ""),
        startCity: get(['startCity', 'name'], product, ""),
        endCity: get(['endCity', 'name'], product, ""),
        brochure: get(['brochure'], product, {}),
        brochureMini: get(['brochureMini'], product, []),
        youTubeLink: _videoId !== null ? `https://www.youtube.com/embed/${_videoId}?rel=0&autoplay=1` : null,
        price:_price,
        includedList:get(['inclusionList'], product, []),
        hasOptions: (get(['options'], product, [])).length > 1 ? true : false,
        hasCapacity: (get(['productCapacity'], product, [])).length > 0 ? true : false
    }
}